import { Injectable } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { LoaderState } from '../_directives/loader/loader';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Injectable()

export class LoadingService {

    private loaderSubject = new Subject<LoaderState>();
    private keepAfterNavigationChange = false;
    loaderState = this.loaderSubject.asObservable();
    @BlockUI() blockUI: NgBlockUI;
    constructor() {}

    show() {
        this.blockUI.start('Loading...');
    }

    hide() {
        this.blockUI.stop();
    }
}